<template>
  <v-app>
    <div v-if="isLoggedInUser">
      <NavigationDrawer></NavigationDrawer>
      <component :is="headerComponent"></component>
      <v-content>
        <v-container fluid class="pa-2">
          <router-view></router-view>
        </v-container>
      </v-content>
    </div>
    <HomeLogin v-else></HomeLogin>

    <!-- <v-dialog v-model="isLoginFormModal" scrollable persistent max-width="600px">
      <LoginForm
        @cancelled="$store.commit('common/setIsLoginFormModal', false)"
        @create="isSignUpFormModal=true"
      />
    </v-dialog>
    <v-dialog v-model="isSignUpFormModal" scrollable persistent max-width="600px">
      <SignUpForm @cancelled="isSignUpFormModal=false" />
    </v-dialog> -->

    <v-snackbar v-model="isSnackbarShow" :multi-line="true" :top="true" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn color="white" flat @click="setIsSnackbarShow(false)">Close</v-btn>
    </v-snackbar>

    <!-- <v-dialog v-model="isdvanceSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearchModal
        :rfilters="advanceSearchFilters"
        @applySearch="advanceSearchApply()"
        @cancelled="modalClose()"
      />
    </v-dialog> -->
  </v-app>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
// import LoginForm from "./components/users/Login";
import HomeLogin from "./components/HomeLogin";
// import SignUpForm from "./components/users/SignUp";
// import HelloWorld from "./components/HelloWorld";
// import FooterCart from "./components/FooterCart";
// import CartDrawer from "./components/CartDrawer";
import VueScrollTo from "vue-scrollto";
import HeaderMobile from "./components/HeaderMobile";
import Header from "./components/Header";
import NavigationDrawer from "./components/NavigationDrawer";
// import AdvanceSearchModal from "./components/SearchModal";

export default {
  name: "App",
  components: {
    // LoginForm,
    // SignUpForm,
    // FooterCart,
    // CartDrawer,
    HeaderMobile,
    NavigationDrawer,
    HomeLogin,
    // AdvanceSearchModal
  },
  data() {
    return {
      // icons: [
      //   "fab fa-facebook",
      //   "fab fa-twitter",
      //   "fab fa-google-plus",
      //   "fab fa-linkedin",
      //   "fab fa-instagram",
      // ],
      // footerCompanyItems: [
      //   { title: "About Us", url: "#", router_name: "" },
      //   { title: "Career", url: "#", router_name: "" },
      //   { title: "Terms of use", url: "#", router_name: "" },
      //   { title: "Privacy Policy after", url: "#", router_name: "" },
      // ],
      // services: [
      //   {
      //     title: "IRON AND PRESSING",
      //     img: require("@/assets/service/iron.png"),
      //     url: "#",
      //   },
      //   {
      //     title: "WASH AND IRON",
      //     img: require("@/assets/service/wash.png"),
      //     url: "#",
      //   },
      //   {
      //     title: "DRY WASH",
      //     img: require("@/assets/service/iron.png"),
      //     url: "#",
      //   },
      //   {
      //     title: "STEAM IRON",
      //     img: require("@/assets/service/wash.png"),
      //     url: "#",
      //   },
      // ],
      // serviceTypes: [
      //   { id: 1, title: "Iron and Pressing" },
      //   { id: 2, title: "Wash and Iron" },
      //   { id: 3, title: "Dry Wash" },
      //   { id: 4, title: "Steam Iron" },
      // ],
      // tempQty: { qty: 1, serviceType: "" },
      // isLoginFormModal: false,
      // isSignUpFormModal: false,
      // myAccountMenuItems: [
      //   { title: "My Profile", router_name: "my_account_profile" },
      //   { title: "My Orders", router_name: "my_account_my_orders" },
      //   { title: "Track My Order", router_name: "my_account_track_my_orders" },
      //   { title: "Logout", router_name: "my_account_logout" },
      // ],
    };
  },
  computed: {
    // ...mapState({
    //   checkoutStatus: (state) => state.cart.checkoutStatus,
    //   serviceCategories: (state) => state.products.all,
    //   isHomePageScrollToOrder: (state) => state.common.isHomePageScrollToOrder,
    // }),
    // ...mapGetters("cart", {
    //   cartProducts: "cartProducts",
    //   // total: "cartTotalPrice"
    //   cartTotalQuantity: "cartTotalQuantity",
    // }),
    ...mapGetters("common", {
      snackbarShowe: "snackbarShow",
      snackbarText: "snackbarText",
      snackbarColor: "snackbarColor",
      logged: "logged",
      isLoginFormModal: "isLoginFormModal",
      isLoggedInUser: "isLoggedIn",
    }),
    isSnackbarShow: {
      get: function () {
        return this.snackbarShowe;
      },
      set: function () {
        this.setIsSnackbarShow(false);
      },
    },
    headerComponent: function () {
      // const { xs, sm, width } = this.$vuetify.breakpoint;
      // return xs || sm ? HeaderMobile : Header;
      return Header;
    },
  },
  methods: {
    // ...mapActions("cart", ["addProductToCart", "removeProductFromCart"]),
    setIsSnackbarShow(isDisplay) {
      this.$store.commit("common/snackbarShow", isDisplay);
    },
    onLoggedOutClicked() {
      this.$store.commit("common/setLogged", {});
      this.$router.push({ name: "home" });
    },
    loadSettings() {
      this.get("/get_settings").then((res) => {
        // console.log(res.data.data);
        this.$store.commit("common/setSettings", res.data.data);
      });
    },
  },
  created() {
    // this.$store.dispatch("products/getAllProducts");
  },
  mounted() {
    this.loadSettings();

    //Scroll to order
    // console.log(this.isHomePageScrollToOrder);
    // if (this.isHomePageScrollToOrder) {
    //   VueScrollTo.scrollTo("#home-our-price-list", 2000);
    // }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");

.application {
  font-family: "Montserrat";
}

.company-menu-container .menu-a {
  color: white;
  text-decoration: none;
}
.service-table {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding: 0;
  margin: 0;
}
.service-table th {
  border: thin solid black;
  margin: 0;
  background-color: #bfbfbf;
  padding: 10px;
  font-size: 20px;
}
.service-table td {
  border: thin solid black;
  padding: 10px;
  font-size: 19px;
}
.category-row {
}



.simple-table-container {
  overflow: auto;
}
.simple-table-container .table {
  border-collapse: collapse;
  width: 100%;
}
.simple-table-container .table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.simple-table-container .table td,
.simple-table-container .table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.simple-table-container .table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}

.simple-table-container .table div{
  width: 100%;
}
</style>